import { SET_VALUE } from "../actions/constantes";

const setValue = (payload) => {
    return{
        type: SET_VALUE,
        payload
    }
};

export default setValue;